import { api } from './index';
import { omitBy } from 'lodash';
import { isNil } from 'utils';

export default {
  getReturnList({ page, limit, q, sortBy, startDate, endDate }) {
    const params = {
      cursor: page,
      end_date: endDate,
      limit,
      q,
      sort_by: sortBy,
      start_date: startDate,
    };
    const url = '/returns/index_order';
    return api.get(url, { params });
  },
  getOrderActivity(id) {
    return api.get(`orders/${id}/returns/activities`);
  },
  acceptReturn(id) {
    return api.post(`orders/${id}/returns/accept_return`);
  },
  rejectReturn(id, payload) {
    return api.post(`orders/${id}/returns/reject_return`, payload);
  },
  acceptShipmentReturn(id) {
    return api.post(`orders/${id}/returns/accept_shipment`);
  },
  setOrderCharged(id, payload) {
    return api.post(`/rent_orders/${id}/charge`, payload);
  },
  setReturnCompleted(id) {
    return api.post(`/rent_orders/${id}/finish_rent`);
  },
  getRentReturnList({ page, limit, q, sortBy, startDate, endDate }) {
    const params = {
      cursor: page,
      end_date: endDate,
      limit,
      q,
      sort_by: sortBy,
      start_date: startDate,
    };
    const url = '/rent_returns/index_order';
    return api.get(url, { params: omitBy(params, isNil) });
  },
};
